// HTML contract:
//   <div class="bf-tabs" role="tablist" data-bf-tabs>
//     <button class="bf-tabs__tab" role="tab" aria-selected="true" data-bf-target="#p1">A</button>
//     <button class="bf-tabs__tab" role="tab" aria-selected="false" data-bf-target="#p2">B</button>
//   </div>
//   <div id="p1" class="bf-tab-panel" role="tabpanel">…</div>
//   <div id="p2" class="bf-tab-panel" role="tabpanel" hidden>…</div>

import { $$, on } from './util';

export function activate(tab: HTMLElement): void {
  const list = tab.closest('[data-bf-tabs], .bf-tabs') as HTMLElement | null;
  if (!list) return;
  for (const t of $$<HTMLElement>('[role="tab"], .bf-tabs__tab', list)) {
    t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
  }
  const targetSel = tab.getAttribute('data-bf-target') ?? `#${tab.getAttribute('aria-controls') ?? ''}`;
  if (!targetSel || targetSel === '#') return;
  const target = document.querySelector(targetSel) as HTMLElement | null;
  if (!target) return;
  // Hide siblings with role=tabpanel that share the same parent.
  const parent = target.parentElement;
  if (parent) {
    for (const panel of $$<HTMLElement>('[role="tabpanel"], .bf-tab-panel', parent)) {
      panel.hidden = panel !== target;
    }
  } else {
    target.hidden = false;
  }
}

export function init(root: ParentNode = document): void {
  for (const list of $$<HTMLElement>('[data-bf-tabs], .bf-tabs', root)) {
    for (const tab of $$<HTMLElement>('[role="tab"], .bf-tabs__tab', list)) {
      on(tab, 'click', (e) => { e.preventDefault(); activate(tab); });
      on(tab, 'keydown', (e) => {
        const k = (e as KeyboardEvent).key;
        if (k !== 'ArrowLeft' && k !== 'ArrowRight') return;
        const tabs = $$<HTMLElement>('[role="tab"], .bf-tabs__tab', list);
        const i = tabs.indexOf(tab);
        const next = k === 'ArrowRight' ? (i + 1) % tabs.length : (i - 1 + tabs.length) % tabs.length;
        tabs[next]!.focus();
        activate(tabs[next]!);
        e.preventDefault();
      });
    }
  }
}
